var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAside(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "278.622px",
    height: "966.047px",
    viewBox: "0 0 278.622 966.047",
    enableBackground: "new 0 0 278.622 966.047",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F4FAFE",
    d: "M193.534,304.497c-26.342-10.238-48.679-30.879-60.368-59.184c-9.782-23.692-10.493-48.843-3.759-71.565 c12.614-31.266,14.111-64.306,1.712-94.331C111.109,30.96,59.922,2.469,0,0v966.047c17.6-13.917,30.572-26.618,40.339-35.22 c17.216-15.161,31.873-32.933,42.274-52.494c25.301-47.588,14.234-100.309-21.019-139.549l0.018-0.016 c-18.687-21.113-24.229-53.311-11.644-86.607c14.133-37.393,47.234-65.893,83.151-75.519c11.089-2.501,22.22-5.998,33.249-10.552 c85.8-35.431,132.817-120.934,103.544-191.824C256.139,340.917,228.197,316.897,193.534,304.497z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAside);
export default __webpack_public_path__ + "static/media/aside.36d0360933d1fc6bd2070192d13d78a1.svg";
export { ForwardRef as ReactComponent };